module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_15_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_15_after.jpg
// module id = 1185
// module chunks = 0